<template>
  <BaseHero
    class="HeroArticle"
    :overlay-opacity="content.overlayOpacity"
    :mobile-overlay-opacity="content.overlayOpacity"
    overlay-gradient
    :max-height="`${content.media.image.height}px`"
    :underlay-navbar="true"
  >
    <template #media>
      <HeroMedia
        :media="content.media"
        is-first
      />
    </template>

    <template #content>
      <slot>
        <BaseCopy
          v-if="formattedDate"
          size="h5"
          :class="$b('date')"
        >
          {{ formattedDate }}
        </BaseCopy>

        <VisionHeading
          v-if="content.title"
          tag="h1"
          size="h1"
          :class="$b('title', { 'full-width': content.fullWidthTitle })"
        >
          {{ content.title }}
        </VisionHeading>

        <VisionHeading
          v-if="content.subtitle"
          tag="h2"
          size="h2"
          :class="$b('subtitle')"
        >
          {{ content.subtitle }}
        </VisionHeading>
      </slot>

      <LinkDirectional
        v-if="hasLink"
        :class="$b('link')"
        :to="content.link.slug"
        :text="content.link.text"
      />
    </template>
  </BaseHero>
</template>

<script>

export default {
  name: 'HeroArticle',

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  computed: {
    formattedDate () {
      return this.$dayjs(this.content.date).format('D MMMM YYYY')
    },

    hasLink () {
      return this.content.link?.text && this.content.link?.slug
    }
  }
}
</script>

<style lang="postcss">
.HeroArticle__date,
.HeroArticle__category {
  @apply uppercase;
}

.HeroArticle__date,
.HeroArticle__title,
.HeroArticle__subtitle {
  @apply mb-xs
    md:mb-sm;
}

.HeroArticle__title {
  @screen short {
    @apply text-2xl;
  }

  @screen lg {
    width: calc((var(--column-width) * 6) + (var(--inner-gutter) * 5));

    &--full-width {
      @apply w-full;
    }
  }

}

.HeroArticle__subtitle {
  @apply opacity-60;
}

.HeroArticle__link {
  @apply -mt-xxxs
    -ml-xxxs
    -mb-xxxs;
}
</style>
